import { gql } from '__generated__';

export default gql(`
  mutation DeleteCoupon($id: ID!) {
    deleteCoupon(id: $id)
  }
`);
